import { UIRouter } from '@uirouter/angular';
import { AppUIRouterConfig } from './app-ui-router.config';

export class BaseRoutes {
  static configure(uiRouter: UIRouter): void {
    AppUIRouterConfig.configure(uiRouter);
  }
}
